import React, { Suspense } from 'react';
import { prop, pick } from 'ramda';
import * as urlUtil from '@core/js/utils/url.util';
import { Link } from '@core/js/components/common/Link';
import { Balance } from '@core/js/components/main/Balance';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useUserSelector, useDeviceSelector, useAppSelector } from '@core/js/store/hooks';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';

import style from './MyBalance.scss';

export const MyBalance: React.FC = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const balancePage = useAppSelector(prop('balancePage'));
    const showBalancePopup = hooks.useShowLowBalancePopup();
    const { showLowBalancePopup, hideBalance, lowBalanceHighlight } = useUserSelector(pick([
       'hideBalance', 'lowBalanceHighlight', 'showLowBalancePopup'
    ]));
    const hideBalanceByUrl = urlUtil.getLocationParam('showHeaderOnlyOnMobile') === '1';

    const content = (
        <span className={`${style.balance} ${lowBalanceHighlight ? style.balanceLow : ''} fn-main-header-user-balance`}>
            <Suspense fallback="">
                <Balance type="casino_gaming_balance" />
            </Suspense>
        </span>
    );

    if (!isDesktop && hideBalanceByUrl && !hideBalance) {
        return null;
    }

    if (showLowBalancePopup) {
        return (
            <AccessibilityElement onClick={showBalancePopup} className={style.balanceWrapper}>
                {content}
            </AccessibilityElement>
        );
    }

    return (
        <Link href={balancePage} className={style.balanceWrapper}>
            {content}
        </Link>
    );
};
